document.addEventListener('DOMContentLoaded', () => {
    const els = document.querySelectorAll('.reveal');
    const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-fade-in');
                obs.unobserve(entry.target); // animacja tylko raz
            }
        });
    }, { threshold: 0.1 });

    els.forEach(el => obs.observe(el));
});
